export default {
    // 查询项目列表
    getProjectList: {
        url: '/xpscdn/getProjects',
        method: 'POST'
    },
    // 删除项目
    deleteProject: {
        url: "/xpscdn/deleteProject",
        method: "post"
    },
    // 查询版本列表
    getVersionList: {
        url: '/xpscdn/getVersion',
        method: 'POST'
    },
    // 查询版本和链接地址列表
    getLinkList: {
        url: '/xpscdn/getlinks',
        method: 'POST'
    },
    // 新建项目
    createProject: {
        url: '/xpscdn/createProject',
        method: 'POST'
    },
    // 新建版本
    createVersion: {
        url: '/xpscdn/createVersion',
        method: 'POST'
    },
    // 上传文件
    openApi: {
        url: "/openApi",
        method: "post"
    },
    // 上传文件
    saveLink: {
        url: "/xpscdn/saveLink",
        method: "post"
    },
    // 删除CDN
    deleteLink: {
        url: "/xpscdn/deleteLink",
        method: "post"
    },
}